//// Application Packages
import React from 'react'
import { useSelector } from 'react-redux'

//// Application Slices
import { selectSettings } from '../../reducers/settingSlice'
import { selectForms } from '../../reducers/formSlice'

//// Application Components
import StateSelectorComponent from '../conditional-components/state-selector-component'
import CountrySelectorComponent from '../conditional-components/country-selector-component'

//// Carbon Components
import {
    TextInput,
    DatePicker,
    DatePickerInput,
    RadioButtonGroup,
    RadioButton,
    Button,
} from '@carbon/react'

//// Carbon Icons
import { Subtract } from '@carbon/icons-react'

//// Static Constants

//////// Component
const AdditionalOtherStateLicensesComponent = ({
    number,
    handleData,
    handleSubtractAdditionalOtherStateLicensesComponent,
}) => {
    //////// Hooks

    //////// State

    //////// Slices
    const settingsData = useSelector(selectSettings)
    const formsData = useSelector(selectForms)

    //// Slice Data

    //////// Search Params

    //////// Methods

    //////// Functional Methods

    //////// Memoization

    //////// Effects/Side Effects

    //////////////// Render & Return

    return (
        <>
            <h4>Additional License:</h4>

            <TextInput
                className="required"
                labelText="License Type:"
                id={'RSD66' + number}
                name={'RSD66' + number}
                placeholder=""
                value={
                    formsData?.[settingsData?.['form']?.['digital_name']]
                        ?.values?.['RSD66' + number]
                }
                maxLength="60"
                type="text"
                onChange={handleData}
                invalid={
                    formsData?.[settingsData?.['form']?.['digital_name']]
                        ?.errors?.['RSD66' + number]
                }
                invalidText={
                    formsData?.[settingsData?.['form']?.['digital_name']]
                        ?.errors?.['RSD66' + number + 'ErrMsg']
                }
            />

            <TextInput
                className="required"
                labelText="License #:"
                id={'RSD169' + number}
                name={'RSD169' + number}
                placeholder=""
                value={
                    formsData?.[settingsData?.['form']?.['digital_name']]
                        ?.values?.['RSD169' + number]
                }
                maxLength="20"
                type="text"
                onChange={handleData}
                invalid={
                    formsData?.[settingsData?.['form']?.['digital_name']]
                        ?.errors?.['RSD169' + number]
                }
                invalidText={
                    formsData?.[settingsData?.['form']?.['digital_name']]
                        ?.errors?.['RSD169' + number + 'ErrMsg']
                }
            />

            <StateSelectorComponent
                digital_name={[settingsData?.['form']?.['digital_name']]}
                value_key={['RSD67' + number]}
                country={
                    formsData?.[settingsData?.['form']?.['digital_name']]
                        ?.values?.['RSD368' + number]
                }
            />

            <CountrySelectorComponent
                digital_name={[settingsData?.['form']?.['digital_name']]}
                value_key={['RSD368' + number]}
                state_value_key={['RSD67' + number]}
                county_value_key=""
            />

            <DatePicker
                dateFormat="m/d/Y"
                datePickerType="single"
                onChange={(e) => handleData(e, ['RSD171' + number])}
                onClose={(e) => handleData(e, ['RSD171' + number])}
                value={
                    formsData?.[settingsData?.['form']?.['digital_name']]
                        ?.values?.['RSD171' + number]
                }
                maxDate={new Date()}
            >
                <DatePickerInput
                    className="required"
                    labelText="Original Date Issued:"
                    id={'RSD171' + number}
                    name={'RSD171' + number}
                    placeholder="MM/DD/YYYY"
                    type="text"
                    invalid={
                        formsData?.[settingsData?.['form']?.['digital_name']]
                            ?.errors?.['RSD171' + number]
                    }
                    invalidText={
                        formsData?.[settingsData?.['form']?.['digital_name']]
                            ?.errors?.['RSD171' + number + 'ErrMsg']
                    }
                />
            </DatePicker>

            <DatePicker
                dateFormat="m/d/Y"
                datePickerType="single"
                onChange={(e) => handleData(e, ['RSD172' + number])}
                onClose={(e) => handleData(e, ['RSD172' + number])}
                value={
                    formsData?.[settingsData?.['form']?.['digital_name']]
                        ?.values?.['RSD172' + number]
                }
                minDate={
                    formsData?.[settingsData?.['form']?.['digital_name']]
                        ?.values?.['RSD171' + number]
                }
            >
                <DatePickerInput
                    className="required"
                    labelText="Expiration Date:"
                    id={'RSD172' + number}
                    name={'RSD172' + number}
                    placeholder="MM/DD/YYYY"
                    type="text"
                    invalid={
                        formsData?.[settingsData?.['form']?.['digital_name']]
                            ?.errors?.['RSD172' + number]
                    }
                    invalidText={
                        formsData?.[settingsData?.['form']?.['digital_name']]
                            ?.errors?.['RSD172' + number + 'ErrMsg']
                    }
                />
            </DatePicker>

            <TextInput
                className="required"
                labelText="Status of License:"
                id={'RSD170' + number}
                name={'RSD170' + number}
                placeholder=""
                value={
                    formsData?.[settingsData?.['form']?.['digital_name']]
                        ?.values?.['RSD170' + number]
                }
                maxLength="50"
                type="text"
                onChange={handleData}
                invalid={
                    formsData?.[settingsData?.['form']?.['digital_name']]
                        ?.errors?.['RSD170' + number]
                }
                invalidText={
                    formsData?.[settingsData?.['form']?.['digital_name']]
                        ?.errors?.['RSD170' + number + 'ErrMsg']
                }
            />

            <RadioButtonGroup
                className={
                    formsData?.[settingsData?.['form']?.['digital_name']]
                        ?.errors?.['ORGLICST' + number]
                        ? 'required invalid'
                        : 'required'
                }
                defaultSelected={
                    formsData?.[settingsData?.['form']?.['digital_name']]
                        ?.values?.['ORGLICST' + number]
                }
                valueSelected={
                    formsData?.[settingsData?.['form']?.['digital_name']]
                        ?.values?.['ORGLICST' + number]
                }
                legendText={
                    'Select "Yes," if this is your Original State of Licensure for this license type.'
                }
                name={'ORGLICST' + number}
                invalid={
                    formsData?.[settingsData?.['form']?.['digital_name']]
                        ?.errors?.['ORGLICST' + number]
                }
                invalidText={
                    formsData?.[settingsData?.['form']?.['digital_name']]
                        ?.errors?.['ORGLICST' + number + 'ErrMsg']
                }
            >
                <RadioButton
                    id={'ORGLICSTYes' + number}
                    name={'ORGLICSTYes' + number}
                    labelText="Yes"
                    value="Y"
                    type="radio"
                    onClick={handleData}
                />
                <RadioButton
                    id={'ORGLICSTNo' + number}
                    name={'ORGLICSTNo' + number}
                    labelText="No"
                    value="N"
                    type="radio"
                    onClick={handleData}
                />
            </RadioButtonGroup>

            <div className="half-width-button-with-icon-group">
                <div className="half-width-button-with-icon-group-item">
                    <Button
                        className="fldoh-btn"
                        name={number}
                        type="button"
                        kind="danger"
                        size="md"
                        onClick={
                            handleSubtractAdditionalOtherStateLicensesComponent
                        }
                    >
                        Remove
                        <Subtract />
                    </Button>
                </div>
            </div>
        </>
    )
}

export default AdditionalOtherStateLicensesComponent
